import { InfoCircleOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.space_5};
`;

export const StyledDiv = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledHeader = styled.h3`
  margin-top: ${({ theme }) => theme.spacing.space_3};
`;

export const StyledTable = styled(Table)`
  width: ${({ theme }) => theme.spacing.space_10};
  margin: ${({ theme }) => theme.spacing.space_3} 0;
  && thead > tr > th {
    padding: ${({ theme }) => theme.spacing.space_3} 0;
    background: none;
    border: none;
    font-weight: 400;
  }
  && thead > tr > th::before {
    background: none !important;
  }
  && tbody > tr > td {
    padding: 0;
    border: none;
  }
  && tbody > tr:hover > td {
    background: none;
  }
`;

export const StyledInfoCircleOutlined = styled(InfoCircleOutlined)`
  margin-left: ${({ theme }) => theme.spacing.space_2};
`;
